import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { MapPin } from "../../../shared/icons";
import { directionsLinks } from "../utils/directionsLinks";

// Itens "Como chegar" para dentro de um Menu já existente (ex.: ações do plantão no
// Calendário). Abrem em nova aba sem dar à página de mapas acesso a esta janela.
export function DirectionsMenuItems({ endereco }) {
  const links = directionsLinks(endereco);
  return (
    <>
      <MenuItem as="a" href={links.googleMaps} target="_blank" rel="noopener noreferrer" icon={<MapPin size={14} />}>
        Como chegar (Google Maps)
      </MenuItem>
      <MenuItem as="a" href={links.waze} target="_blank" rel="noopener noreferrer" icon={<MapPin size={14} />}>
        Como chegar (Waze)
      </MenuItem>
    </>
  );
}

// Botão "Como chegar" com as duas opções de rota. Sem endereço, não aparece.
export default function DirectionsMenu({ endereco, ...buttonProps }) {
  if (!endereco?.trim()) return null;
  const links = directionsLinks(endereco);
  return (
    <Menu placement="bottom-start">
      <MenuButton as={Button} size="sm" variant="ghost" leftIcon={<MapPin size={15} />} {...buttonProps}>
        Como chegar
      </MenuButton>
      <MenuList>
        <MenuItem as="a" href={links.googleMaps} target="_blank" rel="noopener noreferrer">
          Google Maps
        </MenuItem>
        <MenuItem as="a" href={links.waze} target="_blank" rel="noopener noreferrer">
          Waze
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
